var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video",class:{'fixed': _vm.fixed, 'no-video': !_vm.hasVideo, my: _vm.my, speaking: _vm.isSpeaking && !_vm.fixed}},[_vm._t("default"),_c('div',{staticClass:"name"},[_c('span',[_vm._v(_vm._s(_vm.name))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }